/**
 * @desc 获取两位小数规范
 */
function getDecimal(num) {
  let decimal = num.toString().match(/^\d*(\.?\d{0,2})/g)
    ? num === "00"
      ? "0"
      : num.toString().match(/^\d*(\.?\d{0,2})/g)[0]
    : "";
  return decimal;
}

/**
 * @desc 获取正整数
 */
function getPositiveInteger(num) {
  let decimal = num.toString().match(/^(\+)?\d*/g)
    ? num === "00"
      ? "0"
      : num.toString().match(/^(\+)?\d*/g)[0]
    : "";
  return decimal;
}

/**
 * @desc 获取3位小数规范
 */
function getThreeDecimal(num) {
  let decimal = num.toString().match(/^\d*(\.?\d{0,3})/g)
    ? num === "00"
      ? "0"
      : num.toString().match(/^\d*(\.?\d{0,3})/g)[0]
    : "";
  return decimal;
}

/**
 * @desc 获取4位小数规范
 */
function getFourDecimal(num) {
  let decimal = num.toString().match(/^\d*(\.?\d{0,4})/g)
    ? num === "00"
      ? "0"
      : num.toString().match(/^\d*(\.?\d{0,4})/g)[0]
    : "";
  return decimal;
}

/**
 * @desc 限制金额为2位小数（包含负数）
 */
function inputAllTwoDecimal(val) {
  let price = val.toString().match(/^(\-|\+)?\d*(\.?\d{0,2})/g)
    ? val === "00"
      ? "0"
      : val.toString().match(/^(\-|\+)?\d*(\.?\d{0,2})/g)[0]
    : "";
  return price;
}

/**
 * @desc 获取整数规范
 */
function getInteger(num) {
  let integer = num.toString().match(/^[1-9]\d*/)
    ? num.toString().match(/^[1-9]\d*/)[0]
    : num === "0"
    ? "0"
    : "";
  return integer;
}

/**
 * @desc 获取整数规范（包含负数）
 */
function getAllInteger(num) {
  let integer = num.toString().match(/^(\-|\+)?\d*/)
    ? num === "00"
      ? "0"
      : num.toString().match(/^(\-|\+)?\d*/)[0]
    : "";
  return integer;
}

function formatTimeToDate(time) {
  let date = new Date(time);
  let year = date.getFullYear();
  let month = date.getMonth() + 1;
  month = month > 9 ? month : "0" + month;
  let detailDate = date.getDate();
  detailDate = detailDate > 9 ? detailDate : "0" + detailDate;
  return `${year}-${month}-${detailDate}`;
}

function formaTimeToSecond(time) {
  let date = new Date(time);
  let hour = date.getHours();
  hour = hour > 9 ? hour : "0" + hour;
  let minute = date.getMinutes();
  minute = minute > 9 ? minute : "0" + minute;
  let second = date.getSeconds();
  second = second > 9 ? second : "0" + second;
  return `${hour}:${minute}:${second}`;
}

function formaTimeToMinute(time) {
  let date = new Date(time)
  let year = date.getFullYear()
  let month = date.getMonth() + 1
  month = month > 9 ? month : '0' + month
  let detailDate = date.getDate()
  detailDate = detailDate > 9 ? detailDate : '0' + detailDate
  let hour = date.getHours()
  hour = hour > 9 ? hour : '0' + hour
  let minute = date.getMinutes()
  minute = minute > 9 ? minute : '0' + minute
  return `${year}-${month}-${detailDate}  ${hour}:${minute}`
}

function formaTimeToAllSecond(time) {
  let date = new Date(time)
  let year = date.getFullYear()
  let month = date.getMonth() + 1
  month = month > 9 ? month : '0' + month
  let detailDate = date.getDate()
  detailDate = detailDate > 9 ? detailDate : '0' + detailDate
  let hour = date.getHours()
  hour = hour > 9 ? hour : '0' + hour
  let minute = date.getMinutes()
  minute = minute > 9 ? minute : '0' + minute
  let second = date.getSeconds();
  second = second > 9 ? second : "0" + second;
  return `${year}-${month}-${detailDate}  ${hour}:${minute}:${second}`
}

/**
 * @desc 时间戳转化为年月
 */
function formatTimeToYearAndMonth() {
  let date = new Date()
  let year = date.getFullYear()
  let month = date.getMonth() + 1
  month = month > 9 ? month : '0' + month
  return `${year}-${month}`
}

/**
 * @desc 时间戳转化为月日
 */
function formatTimeToMonthAndDay(time) {
  let date = time ? new Date(time) : new Date()
  let month = date.getMonth() + 1
  month = month > 9 ? month : '0' + month
  let detailDate = date.getDate();
  detailDate = detailDate > 9 ? detailDate : "0" + detailDate;
  return `${month}-${detailDate}`
}

function handleGetRequestParams(params) {
  let url = ''
  for (let key in params) {
    let value = (params[key] !== undefined && params[key] !== null) ? params[key] : '';
    url += `&${key}=${encodeURIComponent(value)}`
  }
  return url.substring(1)
}

/** 
 * @desc 计算天数
*/
function calculationDays(start, end) {
  if (start && end) {
    let endTime = new Date(end).getTime() / 1000 - parseInt(new Date(start).getTime() / 1000);
    let timeDay = parseInt(endTime / 60 / 60 / 24);  // 相差天数
    return timeDay + 1
  }
}

/**
 * @desc 把url转为[blob]文件格式(包括图片,pdf,word,excel)下载
 * @params fileName 文件名称
 * @params data 文件的路径
 */
function downLoadFile(fileName, data) {
  if (!data) {
    return
  }
  fetch(data).then(res => res.blob()).then(blob => { // 将链接地址字符内容转变成blob地址
    let url = window.URL.createObjectURL(blob)
    let link = document.createElement('a')
    link.style.display = 'none'
    link.href = url
    link.setAttribute('download', fileName)
    document.body.appendChild(link)
    link.click()
  })
}

/**
 * @desc 下载文件(包括图片,pdf,word,excel)
 * @params res 文件流
 */
function downLoadFileByBlob(res) {
  let blob = new Blob([res.data], { type: res.headers.contentType });
  let fileName = window.decodeURI(
    res.headers["content-disposition"].split("=")[1]
  );
  var url = URL.createObjectURL(blob);
  var a = document.createElement("a");
  a.href = url;
  a.download = fileName;
  a.click();
  // 释放之前创建的URL对象
  window.URL.revokeObjectURL(url);
}

/** 
 * @desc 数字每千位加逗号
 */
function commafy(num) {
  return num && num.toString()
    .replace(/\d+/, function (s) {
      return s.replace(/(\d)(?=(\d{3})+$)/g, '$1,')
    })
}

/**
 * @desc 数字加人民币符号和千分位
 * @params num 数字
*/
function numsToRMBSymbolAndMillimeter(num) {
  let nums = `￥${commafy(num)}`
  return nums
}

/**
 * @desc 树结构所有对象筛选
 */
function treeFindPath(tree, func, path = []) {
  if (!tree) return []
  for (const data of tree) {
    path.push(data)
    if (func(data)) return path
    if (data.children) {
      const findChildren = treeFindPath(data.children, func, path)
      if (findChildren.length) return findChildren
    }
    path.pop()
  }
  return []
}

/**
 * @desc 树结构筛选
 */
function treeFilter(tree, func) {
  // 使用map复制一下节点，避免修改到原树
  return tree.map(node => ({ ...node })).filter(node => {
    node.children = node.children && treeFilter(node.children, func)
    return func(node) || (node.children && node.children.length)
  })
}

/**
 * @desc 四舍五入保留2位小数（若第二位小数为0，则保留一位小数）
 */
function keepTwoDecimal(num) {
  let result = parseFloat(num);
  if (isNaN(result)) {
    alert('传递参数错误，请检查！');
    return false;
  }
  result = Math.round(num * 100) / 100;
  return result;
}

/* 防抖 */
function debounce(fn, delay) {
  let timer = null
  return function () {
    if (timer) {
      clearTimeout(timer)
      console.log('拦截')
    }
    timer = setTimeout(() => {
      console.log('发送')

      fn.apply(this, arguments)
      timer = null
    }, delay)
  }
}

/* 前端搜索 */
function fuzzyQuery(tree, func) {
  // 使用map复制一下节点，避免修改到原树
  return tree.map(node => ({ ...node })).filter(node => {
    node.children = node.children && fuzzyQuery(node.children, func)
    return func(node) || (node.children && node.children.length)
  })
}

export { 
  getDecimal, 
  getPositiveInteger,
  getThreeDecimal,
  getFourDecimal,
  inputAllTwoDecimal, 
  getInteger, 
  getAllInteger,
  formatTimeToDate, 
  formaTimeToMinute, 
  formatTimeToYearAndMonth, 
  formatTimeToMonthAndDay,
  formaTimeToSecond, 
  formaTimeToAllSecond, 
  handleGetRequestParams, 
  downLoadFile, 
  commafy, 
  numsToRMBSymbolAndMillimeter, 
  treeFindPath, 
  treeFilter, 
  keepTwoDecimal,
  debounce,
  fuzzyQuery,
  calculationDays,
  downLoadFileByBlob
};
